import axios from '../axios'

/**
 * 奖惩列表
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const list = (data) => {
  return axios({
    url: '/mRewardsPunishments/list',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

/**
 * 保存奖惩
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const save = (data) => {
  return axios({
    url: '/mRewardsPunishments/save',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

/**
 * 删除奖惩
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const batchDelete = (data) => {
  return axios({
    url: '/mRewardsPunishments/delete',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/rewardsPunishments.js